var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3283_4285)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#E6E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM10.5527 6.45716C8.28924 7.04653 6.57055 8.9857 6.30768 11.3636H8.85006C8.99273 9.60525 9.58125 7.91736 10.5527 6.45716ZM13.4473 6.45716C14.4188 7.91736 15.0073 9.60525 15.1499 11.3636H17.6923C17.4295 8.9857 15.7108 7.04653 13.4473 6.45716ZM13.8724 11.3636C13.7126 9.63707 13.0625 7.99214 12 6.62323C10.9375 7.99214 10.2874 9.63707 10.1276 11.3636H13.8724ZM10.1276 12.6364H13.8724C13.7126 14.3629 13.0625 16.0079 12 17.3768C10.9375 16.0079 10.2874 14.3629 10.1276 12.6364ZM8.85006 12.6364H6.30768C6.57055 15.0143 8.28924 16.9535 10.5527 17.5428C9.58125 16.0826 8.99273 14.3948 8.85006 12.6364ZM13.4473 17.5428C14.4188 16.0826 15.0073 14.3948 15.1499 12.6364H17.6923C17.4295 15.0143 15.7108 16.9535 13.4473 17.5428Z",
    fill: "#F8009E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3283_4285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGlobe);
export default __webpack_public_path__ + "static/media/icon-globe.82d60664ed84e5634bc805ec7f8548e5.svg";
export { ForwardRef as ReactComponent };